import React, { useState, useRef, useEffect } from "react";


export default function ConceptArt() {

    var sectionStyle1 = {
        backgroundImage: `url('illustration154.png')`
    };
    var sectionStyle2 = {
        backgroundImage: `url('illustration172.jpg')`
    };
    var sectionStyle3 = {
        backgroundImage: `url('illustration145.jpg')`
    };
    var sectionStyle4 = {
        backgroundImage: `url('illustration152.jpg')`
    };
    var sectionStyle5 = {
        backgroundImage: `url('Concept art 1.jpg')`
    };
    var sectionStyle6 = {
        backgroundImage: `url('Tyro_vatsal.jpeg')`
    };
 

    var sections = [ sectionStyle1, sectionStyle2, sectionStyle3, sectionStyle4, sectionStyle5,sectionStyle6]

    var [sectionStyle, setStyle] = useState([])
    
    
    return (
        <>
            <div className="cild3">
                <a href="/"><button className="left-slide" ><img src="back_arrow.svg" /></button></a>
                <p className="ca">Concept Arts</p>
                
                <div className="enlarged-back"><div style={sectionStyle} className="enlarged"></div></div>
                
                
                <div className="carosuel-back">
                    <div className="carosuel">
                        <ul>
                            <li onClick={ (e) => setStyle(sectionStyle1) } style={sections[0]}></li>
                            <li onClick={ (e) => setStyle(sectionStyle2) } style={sections[1]}></li>
                            <li onClick={ (e) => setStyle(sectionStyle3) } style={sections[2]}></li>
                            <li onClick={ (e) => setStyle(sectionStyle4) } style={sections[3]}></li>
                            <li onClick={ (e) => setStyle(sectionStyle5) } style={sections[4]}></li>
                            <li onClick={ (e) => setStyle(sectionStyle6) } style={sections[5]}></li>
                        </ul>
                    </div>
                </div>
                
            </div>
        </>
    );
}